import type { AccountKey, MailboxInfo } from 'owa-client-types';
import { getAccountKeyForMailboxInfo } from 'owa-client-types';

/**
 * Server-side runtime properties for an account, captured during
 * account startup so downstream consumers (e.g. analytics init)
 * can read them without re-fetching start data.
 */
export interface OwaServerProperties {
    forest?: string;
    serviceVersion?: string;
    backend?: string;
}

const owaServerPropertiesByAccount = new Map<AccountKey, OwaServerProperties>();

export function setOwaServerPropertiesForAccount(
    mailboxInfo: MailboxInfo,
    properties: OwaServerProperties
): void {
    owaServerPropertiesByAccount.set(getAccountKeyForMailboxInfo(mailboxInfo), properties);
}

export function getOwaServerPropertiesForAccount(
    mailboxInfo: MailboxInfo
): OwaServerProperties | undefined {
    return owaServerPropertiesByAccount.get(getAccountKeyForMailboxInfo(mailboxInfo));
}

export function clearOwaServerPropertiesForAccount(mailboxInfo: MailboxInfo): void {
    owaServerPropertiesByAccount.delete(getAccountKeyForMailboxInfo(mailboxInfo));
}
